import React from 'react';
import { motion } from 'framer-motion';

function StepSelectUniversidad({ universidades, loadingUniversidades, onSelect }) {
  return (
    <div>
      <div className="mb-8 text-center">
        <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl bg-blue-100 dark:bg-blue-900/30 mb-4">
          <span className="material-icons-round text-3xl text-[#2D5BA6]">account_balance</span>
        </div>
        <h2 className="text-2xl font-bold text-slate-900 dark:text-white">Seleccionar Universidad</h2>
        <p className="text-slate-500 dark:text-slate-400 mt-2">
          Elige la universidad para buscar sus investigadores y publicaciones
        </p>
      </div>

      {loadingUniversidades ? (
        <div className="flex items-center justify-center py-16">
          <div className="flex flex-col items-center gap-3">
            <div className="w-10 h-10 border-4 border-[#2D5BA6] border-t-transparent rounded-full animate-spin" />
            <span className="text-slate-500 dark:text-slate-400">Cargando universidades...</span>
          </div>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {universidades.map((univ, idx) => (
            <motion.button
              key={univ.id}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: idx * 0.05 }}
              onClick={() => onSelect(univ)}
              className="group flex flex-col items-start gap-3 p-5 bg-white dark:bg-slate-800 border-2 border-slate-200 dark:border-slate-700 rounded-xl hover:border-[#2D5BA6] dark:hover:border-[#5B8BD9] hover:shadow-lg transition-all text-left"
            >
              <div className="flex items-center gap-3 w-full">
                <div className="w-10 h-10 rounded-lg bg-blue-50 dark:bg-blue-900/20 flex items-center justify-center flex-shrink-0 group-hover:bg-blue-100 dark:group-hover:bg-blue-900/40 transition-colors">
                  <span className="material-icons-round text-xl text-[#2D5BA6]">school</span>
                </div>
                <div className="min-w-0">
                  <p className="font-bold text-slate-900 dark:text-white text-sm truncate">{univ.siglas || univ.short_name}</p>
                  <p className="text-xs text-slate-500 dark:text-slate-400">{univ.ciudad || univ.country}</p>
                </div>
              </div>
              <p className="text-xs text-slate-600 dark:text-slate-300 leading-snug line-clamp-2">{univ.name}</p>
              <div className="flex items-center gap-1 text-[#2D5BA6] dark:text-[#5B8BD9] text-xs font-semibold mt-auto group-hover:gap-2 transition-all">
                <span>Seleccionar</span>
                <span className="material-icons-round text-base">arrow_forward</span>
              </div>
            </motion.button>
          ))}
        </div>
      )}
    </div>
  );
}

export default StepSelectUniversidad;
